<template>
  <div id="app">
    <app-svg-container />
    <app-header />
    <app-mobile-navigation />
    <main class="main-layout">
      <transition name="trs-fade-out">
        <router-view :key="$route.path"/>
      </transition>
    </main>
    <app-footer />
    <app-booking />
    <portal-target name="email-confirmation" multiple />
    <app-photo-swipe-lib />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import AppSvgContainer from '@/components/AppSvgContainer.vue'
  import AppHeader from '@/components/AppHeader.vue'
  import AppMobileNavigation from '@/components/AppMobileNavigation.vue'
  import AppFooter from '@/components/AppFooter.vue'
  import AppBooking from '@/components/AppBooking.vue'
  import AppPhotoSwipeLib from "@/components/AppPhotoSwipeLib";

  export default {
    components: {
      AppHeader,
      AppFooter,
      AppSvgContainer,
      AppMobileNavigation,
      AppBooking,
      AppPhotoSwipeLib
    },
    created() {
      if (localStorage.getItem('token') !== null) {
        this.checkUser();
      }
    },
    methods: {
      ...mapActions('auth', ['checkUser']),
    },
  }
</script>

<style lang="scss">
  @import "assets/styles/main";
</style>
